import { gql } from '@apollo/client';

export const USER_GROUP_LIST_QUERY = gql`
  query userGroupList($pager: PagerInputNew, $filters: UserGroupFilterInput) {
    userGroupList(pager: $pager, filters: $filters) {
      total
      values {
        id
        code
        name
      }
    }
  }
`;
